// Public assets (static assets)
export const authBackground = "/assets/auth-background.png";

// Assimagra Logos
export const assimagraLogo = "/assets/logos/assimagra/logo.png";
export const assimagraLogoSmall = "/assets/logos/assimagra/logo-small.png";
export const assimagraLogoWhite = "/assets/logos/assimagra/logo-white.png";
export const stonePrintLogoWhite = "/assets/logos/stoneprint/Assimagra-StonePrintLogo-Negativo.png";

// Footer Logos
export const footerUE = "/assets/logos/footer/UE.png";
export const footerPRR = "/assets/logos/footer/prr.png";
export const footerPortugueseRepublic = "/assets/logos/footer/portuguese_republic.png";
export const footerSustainableStone = "/assets/logos/footer/sustainable-stone.png";
export const poweredTech2c = "/assets/logos/get2c/powered-tech2c.png";
